import AccountPage from 'screens/Account/Account';

export default AccountPage;
